<h1 class="mb-2">
  <mdb-icon fas icon="tasks"></mdb-icon> Censo
</h1>

<!-- Heading -->
<div class="card card-miga-pan mb-2 wow">
  <!--Card content-->
  <div class="card-body d-sm-flex p-1 justify-content-between">
    <p class="mb-0">
      <span class="grey-text">Máquinas</span>
      <span> /</span>
      <span>Censo</span>
    </p>
  </div>
</div>
<!-- Heading -->

<!-- Cabecera de botones -->
<div class="card mb-2 wow detalle-cliente">
  <div class="card-body justify-content-between">
    <div class="row filtros-header justify-content-end" style="border-bottom: 1px solid #dee2e6">
      <div></div>
      <button type="button" mdbBtn color="info" mdbWavesEffect size="sm" (click)="censoMaquina.show()">
        Reaclizar Doc.
      </button>
    </div>

    <div class="row filtros-body">
      <div class="col" style="max-width: 200px">
        <div class="md-form">
          <mdb-date-picker [inline]="true" name="fechaDesde" [placeholder]="'Fecha'" required></mdb-date-picker>
        </div>
      </div>
      <div class="col" style="max-width: 200px">
        <div class="md-form">
          <mdb-date-picker [inline]="true" name="fechaHasta" [placeholder]="'Hasta'" required></mdb-date-picker>
        </div>
      </div>
      <div class="col" style="max-width: 200px">
        <div class="md-form">
          <input value="" type="text" id="idreport" class="form-control" placeholder="123123" required #idreport />
          <label for="idreport">ID Reporte</label>
        </div>
      </div>
    </div>

  </div>
  <!-- FOOTER -->
  <div class="card-footer text-muted filtros-footer" style="border-top: 1px solid #dee2e6">
    <div></div>
    <button mdbBtn type="button" color="secondary" size="sm" mdbWavesEffect>
      <mdb-icon fas icon="search"></mdb-icon>
      Buscar
    </button>
  </div>
</div>

<div class="card mb-2 wow detalle-cliente">
  <div class="card-body justify-content-between">
    <div class="table-responsive">
      <table class="table table-striped table-hover table-sm align-middle">
        <thead class="grey lighten-2">
          <tr>
            <th scope="col" style="width: 100px">Resumen</th>
            <th scope="col">Nro. Dcto.</th>
            <th scope="col">Fecha</th>
            <th scope="col">Vendedor</th>
            <th scope="col">Estado</th>
            <th scope="col">Toma inventario</th>
          </tr>
        </thead>

        <tbody>
          <tr>
            <td align="center">
              <button mdbBtn type="button" size="sm" color="info" mdbWavesEffect class="btn-actions-sm" mdbTooltip="Ver"
                placement="right" (click)="consultaMaquina.show()">
                <mdb-icon fas icon="eye"></mdb-icon>
              </button>
            </td>
            <td>100023</td>
            <td>04/01/2020</td>
            <td>Vendedor 1</td>
            <td>
              <mdb-badge pill="true" default="true">Pendiente</mdb-badge>
            </td>
            <td>
              <button mdbBtn type="button" color="info" mdbWavesEffect class="btn text-center" size="sm"
                mdbTooltip="Ingresar Documento" placement="right" (click)="reporteMaquina.show()">
                Ingresar
              </button>
              <button mdbBtn type="button" size="sm" color="primary" mdbWavesEffect class="btn-actions-sm"
                mdbTooltip="Eliminar" placement="right">
                <mdb-icon fas icon="trash"></mdb-icon>
              </button>
            </td>
          </tr>
          <tr>
            <td align="center">
              <button mdbBtn type="button" size="sm" color="info" mdbWavesEffect class="btn-actions-sm" mdbTooltip="Ver"
                placement="right" (click)="consultaMaquina.show()">
                <mdb-icon fas icon="eye"></mdb-icon>
              </button>
            </td>
            <td>100023</td>
            <td>04/01/2020</td>
            <td>Vendedor 1</td>
            <td>
              <mdb-badge pill="true" danger="true">Eliminado</mdb-badge>
            </td>
            <td>
              <button mdbBtn type="button" color="info" mdbWavesEffect class="btn text-center" size="sm"
                mdbTooltip="Ingresar Documento" placement="right" (click)="reporteMaquina.show()">
                Ingresar
              </button>
              <button mdbBtn type="button" size="sm" color="primary" mdbWavesEffect class="btn-actions-sm"
                mdbTooltip="Eliminar" placement="right">
                <mdb-icon fas icon="trash"></mdb-icon>
              </button>
            </td>
          </tr>
          <tr>
            <td align="center">
              <button mdbBtn type="button" size="sm" color="info" mdbWavesEffect class="btn-actions-sm" mdbTooltip="Ver"
                placement="right" (click)="consultaMaquina.show()">
                <mdb-icon fas icon="eye"></mdb-icon>
              </button>
            </td>
            <td>100023</td>
            <td>04/01/2020</td>
            <td>Vendedor 1</td>
            <td>
              <mdb-badge pill="true" success="true">Procesado</mdb-badge>
            </td>
            <td>
              <button mdbBtn type="button" color="info" mdbWavesEffect class="btn text-center" size="sm"
                mdbTooltip="Ingresar Documento" placement="right" (click)="reporteMaquina.show()">
                Ingresar
              </button>
              <button mdbBtn type="button" size="sm" color="primary" mdbWavesEffect class="btn-actions-sm"
                mdbTooltip="Eliminar" placement="right">
                <mdb-icon fas icon="trash"></mdb-icon>
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>

<div class="card mb-2 wow">
  <div class="card-body d-sm-flex p-1 justify-content-end">
    <button size="sm" mdbBtn type="button" color="success" mdbWavesEffect class="btn btn-sm">
      Excel
    </button>

    <button size="sm" mdbBtn type="button" color="success" mdbWavesEffect class="btn btn-sm">
      PDF
    </button>
  </div>
</div>




<!-- MODAL censoMaquina -->
<div mdbModal #censoMaquina="mdb-modal" class="modal fade" id="basicExample" tabindex="-1" role="dialog"
  aria-labelledby="myModalLabel" aria-hidden="true" [config]="{ backdrop: true, ignoreBackdropClick: true }">
  <div class="modal-dialog modal-fluid" role="document" style="max-width: 90%;">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title w-100 text-left" id="myModalLabel">
          Censo de máquina
        </h4>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="censoMaquina.hide()">
          <span aria-hidden="true">×</span>
        </button>
      </div>
      <div class="modal-body">
        <div class="row">
          <div class="col dato" style="max-width: 250px;">
            <Strong class="title">ID Reporte:</Strong>&nbsp;
            <span class="value">100006</span>
          </div>
          <div class="col dato" style="max-width: 250px;">
            <Strong class="title">Fecha:</Strong>&nbsp;
            <span class="value">06/05/2020</span>
          </div>
          <div class="col dato" style="max-width: 250px;">
            <Strong class="title">Vendedor:</Strong>&nbsp;
            <span class="value">JORGE VARGAS</span>
          </div>
        </div>

        <div class="row">
          <div class="col">
            <div class="table-responsive">
              <table class="table table-striped table-hover table-sm align-middle">
                <thead class="grey lighten-2">
                  <tr>
                    <th>Cliente</th>
                    <th>N° Placa</th>
                    <th>Marca</th>
                    <th>Modelo</th>
                    <th>Estado</th>
                    <th>Estado Actual</th>
                    <th>Observaciones</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>AARON CASTILLO IBAZETA</td>
                    <td>141</td>
                    <td>SAMSUNG</td>
                    <td>CV 350</td>
                    <td>
                      <mdb-badge pill="true" success="true">Buena</mdb-badge>
                      <!-- <mdb-badge pill="true" danger="true" >Inactivo</mdb-badge> -->
                    </td>
                    <td>

                      <mdb-select [options]="optionsEstadoActual" placeholder="Estado Actual" [filterEnabled]="true">
                      </mdb-select>

                    </td>
                    <td>
                      <input mdbInput type="text" class="form-control" placeholder="Observaciones...">
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer justify-content-between">
        <button size="sm" type="button" class="btn btn-sm btn-default waves-light" data-dismiss="modal"
          (click)="censoMaquina.hide()" mdbWavesEffect>
          Cerrar
        </button>
        <button size="sm" type="button" class="btn btn-sm btn-secondary waves-light" mdbWavesEffect
          (click)="censoMaquina.hide()">
          Actualizar
        </button>
      </div>
    </div>
  </div>
</div>


<!-- MODAL consultaMaquina -->
<div mdbModal #consultaMaquina="mdb-modal" class="modal fade" id="basicExample" tabindex="-1" role="dialog"
  aria-labelledby="myModalLabel" aria-hidden="true" [config]="{ backdrop: true, ignoreBackdropClick: true }">
  <div class="modal-dialog modal-lg" role="document" style="max-width: 90%;">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title w-100 text-left" id="myModalLabel">
          Consulta de máquina
        </h4>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="consultaMaquina.hide()">
          <span aria-hidden="true">×</span>
        </button>
      </div>
      <div class="modal-body">
        <div class="row">
          <div class="col dato" style="max-width: 250px;">
            <Strong class="title">ID Reporte:</Strong>&nbsp;
            <span class="value">100006</span>
          </div>
          <div class="col dato" style="max-width: 250px;">
            <Strong class="title">Fecha:</Strong>&nbsp;
            <span class="value">06/05/2020</span>
          </div>
          <div class="col dato" style="max-width: 250px;">
            <Strong class="title">Vendedor:</Strong>&nbsp;
            <span class="value">JORGE VARGAS</span>
          </div>
        </div>

        <div class="row">
          <div class="col">
            <div class="table-responsive">
              <table class="table table-striped table-hover table-sm align-middle">
                <thead class="grey lighten-2">
                  <tr>
                    <th>Cliente</th>
                    <th>N° Placa</th>
                    <th>Marca</th>
                    <th>Modelo</th>
                    <th>Estado</th>
                    <th>Estado Actual</th>
                    <th>Observaciones</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>AARON CASTILLO IBAZETA</td>
                    <td>141</td>
                    <td>SAMSUNG</td>
                    <td>CV 350</td>
                    <td>
                      <mdb-badge pill="true" success="true">Buena</mdb-badge>
                      <!-- <mdb-badge pill="true" danger="true" >Inactivo</mdb-badge> -->
                    </td>
                    <td>
<mdb-badge pill="true" danger="true">Mala</mdb-badge>
                      

                    </td>
                    <td>
                      Mal Uso del equipo
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer justify-content-between">
        <button size="sm" type="button" class="btn btn-sm btn-default waves-light" data-dismiss="modal"
          (click)="consultaMaquina.hide()" mdbWavesEffect>
          Cerrar
        </button>
        <button size="sm" type="button" class="btn btn-sm btn-secondary waves-light" mdbWavesEffect
          (click)="consultaMaquina.hide()">
          Imprimir
        </button>
      </div>
    </div>
  </div>
</div>

<!-- MODAL reporteMaquina -->
<div mdbModal #reporteMaquina="mdb-modal" class="modal fade" id="basicExample" tabindex="-1" role="dialog"
  aria-labelledby="myModalLabel" aria-hidden="true" [config]="{ backdrop: true, ignoreBackdropClick: true }">
  <div class="modal-dialog modal-lg" role="document" style="max-width: 90%;">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title w-100 text-left" id="myModalLabel">
          Reporte de máquina
        </h4>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="reporteMaquina.hide()">
          <span aria-hidden="true">×</span>
        </button>
      </div>
      <div class="modal-body">
        <div class="row">
          <div class="col" style="max-width: 150px">
            <div class="md-form">
              <input value="" type="text" id="rutvende" class="form-control" placeholder="9.999.999-9" required #rutvende />
              <label for="rutvende">RUT vendedor</label>
            </div>
          </div>
          <div class="col d-flex" style="max-width: 300px">
            <button mdbBtn type="button" class="btn-cuadrado" color="secondary" mdbWavesEffect
              (click)="seleccionarVendedor.show()">
              <mdb-icon fas icon="search"></mdb-icon>
            </button>
            <h6 class="text-info" style="display: contents">
              Nombre de vendedor
            </h6>
          </div>
        </div>
        

        
        <div class="row">
          <div class="col" style="max-width: 50px;">
            <h5>IPT</h5>
          </div>
          <div class="col">
            <mdb-checkbox>Lunes </mdb-checkbox>
          </div>
          <div class="col">
            <mdb-checkbox>Martes </mdb-checkbox>
          </div>
          <div class="col">
            <mdb-checkbox>Miercoles </mdb-checkbox>
          </div>
          <div class="col">
            <mdb-checkbox>Jueves </mdb-checkbox>
          </div>
          <div class="col">
            <mdb-checkbox>Viernes </mdb-checkbox>
          </div>
          <div class="col">
            <mdb-checkbox>Sábado </mdb-checkbox>
          </div>
          <div class="col">
            <mdb-checkbox>Domingo </mdb-checkbox>
          </div>
          <div class="col">
            <mdb-checkbox>Todos </mdb-checkbox>
          </div>
        </div>

                <div class="filtros-body" style="border-top: 1px solid #dee2e6">
                  <div></div>
                  <button mdbBtn class="btn btn-sm" type="button" color="secondary" size="sm" mdbWavesEffect>
                    <mdb-icon fas icon="search"></mdb-icon>
                    Buscar
                  </button>
                </div>

        <div class="row">
          <div class="col">
            <div class="table-responsive">
              <table class="table table-striped table-hover table-sm align-middle">
                <thead class="grey lighten-2">
                  <tr>
                    <th>Cliente</th>
                    <th>N° Placa</th>
                    <th>Marca</th>
                    <th>Modelo</th>
                    <th>IPT</th>

                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>AARON CASTILLO IBAZETA</td>
                    <td>141</td>
                    <td>SAMSUNG</td>
                    <td>CV 350</td>
                    <td>
                      LUNES
                    </td>

                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer justify-content-between">
        <button size="sm" type="button" class="btn btn-sm btn-default waves-light" data-dismiss="modal"
          (click)="reporteMaquina.hide()" mdbWavesEffect>
          Cerrar
        </button>
        <button size="sm" type="button" class="btn btn-sm btn-secondary waves-light" mdbWavesEffect
          (click)="reporteMaquina.hide()">
          Imprimir
        </button>
      </div>
    </div>
  </div>
</div>

<!-- MODAL seleccionarVendedor -->
<div mdbModal #seleccionarVendedor="mdb-modal" class="modal fade" id="basicExample" tabindex="-1" role="dialog"
  aria-labelledby="myModalLabel" aria-hidden="true" [config]="{ backdrop: true, ignoreBackdropClick: true }">
  <div class="modal-dialog modal-lg" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title w-100 text-left" id="myModalLabel">
          Seleccionar vendedor
        </h4>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close"
          (click)="seleccionarVendedor.hide()">
          <span aria-hidden="true">×</span>
        </button>
      </div>
      <div class="modal-body">
        <div class="row">
          <div class="col">
            <div class="md-form">
              <input value="" type="text" id="rutVend" class="form-control" placeholder="Nombre o RUT del vendedor"
                required #rutVend />
              <label for="rutVend">Nombre o RUT del vendedor</label>
            </div>
          </div>
          <div class="col" style="width: 50px">
            <button mdbBtn type="button" class="btn-cuadrado" color="secondary" mdbWavesEffect
              (click)="seleccionarVendedor.show()">
              <mdb-icon fas icon="search"></mdb-icon>
            </button>
          </div>
        </div>
        <table class="table table-striped table-hover table-sm align-middle">
          <thead class="grey lighten-2">
            <tr>
              <th scope="col" class="text-center">RUT</th>
              <th scope="col" class="text-center">Nombre</th>
              <th scope="col" class="text-center">Sucursal</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>99.999.999-9</td>
              <td>Nombre vendedor</td>
              <td>Matriz</td>
              <td>
                <button mdbBtn type="button" color="indigo" mdbWavesEffect class="btn" size="sm"
                  (click)="seleccionarVendedor.hide()">
                  Seleccionar
                </button>
              </td>
            </tr>
            <tr>
              <td>99.999.999-9</td>
              <td>Nombre vendedor</td>
              <td>Matriz</td>
              <td>
                <button mdbBtn type="button" color="indigo" mdbWavesEffect class="btn" size="sm"
                  (click)="seleccionarVendedor.hide()">
                  Seleccionar
                </button>
              </td>
            </tr>
            <tr>
              <td>99.999.999-9</td>
              <td>Nombre vendedor</td>
              <td>Matriz</td>
              <td>
                <button mdbBtn type="button" color="indigo" mdbWavesEffect class="btn" size="sm"
                  (click)="seleccionarVendedor.hide()">
                  Seleccionar
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>